export const COMPETITION_ID = '-OQwsUiJRmM9Yy2x0n8n';
